
export const TRANSACTION_HISTORY_TABLE_CONSTANTS = {
    ROW_HEIGHT: 73, 
    HEADER_HEIGHT: 56, 
    PAGINATION_HEIGHT: 64, 
    SEARCH_BAR_HEIGHT: 80, 
    TABS_HEIGHT: 48, 
    PADDING_BUFFER: 20, 
    MIN_ROWS: 1,
    
    RESIZE_DEBOUNCE_DELAY: 100, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    SEARCH_PLACEHOLDER: 'Search Transactions...',
    NO_TRANSACTIONS_MESSAGE: 'No transactions found',
    LOADING_MESSAGE: 'Loading transactions...',
    
    SHOWING_TEXT: 'Showing',
    TO_TEXT: 'to',
    OF_TEXT: 'of',
    TRANSACTIONS_TEXT: 'transactions'
  } as const;